module.exports = __webpack_public_path__ + "img/banjiang.37b30254.png";